import { Component, OnInit,Input,Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-object-select-list',
  templateUrl: './object-select-list.component.html',
  styleUrls: ['./object-select-list.component.less']
})
export class ObjectSelectListComponent implements OnInit {

  @Input() data: any =[];
  @Input() record = 0;
  @Output() navigate =  new EventEmitter<any>();
  current = 1;
  myControl = new UntypedFormControl();
  fiteredData : any = []


  constructor() { }

  ngOnInit(): void {

    this.fiteredData = this.myControl.valueChanges
    .pipe(
      startWith(''),
      map(name => name ? this._filter(name) : this.data.slice())
    );
  }

  private _filter(filter: string): any[] {
    let filterValue = '';
    if (filter.toLocaleLowerCase) filterValue = filter.toLowerCase();
    return this.data.filter(option => ('' + option.ObjectNummer + '-' + option.ObjectSerieNr).toLowerCase().indexOf(filterValue) === 0);
  }

  displayObject(data: any) : string {
      if (data == null) return '';
      return data.ObjectNummer + "-" + data.ObjectSerieNr;
  }


  change(event:any) {
    console.log(event);
  }


  select(ID:number) {
    const dataindex = this.data.findIndex(item=> item.ID == ID );
    this.navigate.emit({ID: ID, record:dataindex});
  }

}
